export default class Faq {
  constructor(el) {
    this.el = el
    this.items = null
    this.init()
  }

  init() {
    this.items = this.el.querySelectorAll('.faq--item')
    this.items.forEach(item => {
      item.querySelector('.faq--question').addEventListener('click', () => this.toggle(item))
    })
  }

  toggle(item) {
    const isOpen = item.classList.contains('is-open')

    this.items.forEach(i => {
      i.classList.remove('is-open')
      i.querySelector('.faq--response').style.height = '0'
    })

    if (!isOpen) {
      const response = item.querySelector('.faq--response')
      item.classList.add('is-open')
      response.style.height = response.scrollHeight + 'px'
    }
  }
}
